import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import {
  deleteSubUnidadDeRecaudacion,
  getSubUnidadesDeRecaudacion,
  patchSubUnidadDeRecaudacion,
  postSubUnidadDeRecaudacion,
} from 'api/configuracion/subUnidadesDeRecaudacion';

// eslint-disable-next-line react/prop-types
const SubunidadesRecaudadoras = ({ permission }) => (
  <PlainCRUD
    title="Subunidad Recuadadora"
    permission={permission}
    get={getSubUnidadesDeRecaudacion}
    post={postSubUnidadDeRecaudacion}
    patch={patchSubUnidadDeRecaudacion}
    delete={deleteSubUnidadDeRecaudacion}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'unidad_de_recaudacion',
        label: 'Unidad de Recaudación',
        labelProp: 'descripcion',
        type: 'select',
        required: true,
        colWidth: 200,
        useCatalog: true,
      },
      {
        name: 'abreviatura',
        label: 'Abreviatura',
      },

    ]}
    catalogs={[
      {
        permission: 'unidadderecaudacion',
        get: getUnidadesDeRecaudacion,
        formItemName: 'unidad_de_recaudacion',
      },
    ]}
  />
);

export default SubunidadesRecaudadoras;
